import React, { useCallback, useEffect, useMemo, useState } from 'react';

import cx from 'clsx';
import type { OwnProps } from 'SizeGuide';

import Styles from './SizeGuide.module.scss';

const defaultUnit = localStorage.getItem('sizeGuideUnit');

export const SizeGuide: React.FC<OwnProps> = ({ show, onClose, measurementChart }) => {
  const units = useMemo(() => measurementChart.unit.split('/').map(unit => unit.trim()), [measurementChart.unit]);
  const preselectedUnit = Math.max(0, units.indexOf(defaultUnit));

  const [selectedUnit, setSelectedUnit] = useState(preselectedUnit);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.removeAttribute('style');
    }
  }, [show]);

  const handleSelectUnit = useCallback(
    (unit: string) => {
      setSelectedUnit(units.indexOf(unit));
      localStorage.setItem('sizeGuideUnit', unit);
    },
    [units],
  );

  return (
    <div
      className={cx(Styles.wrapper, {
        show,
      })}
    >
      <div className={Styles.overlay} onClick={onClose} />
      <div className={Styles.inner}>
        <header className={Styles.header}>
          <span>Size guide</span>
          <button type="button" className={Styles.closeButton} onClick={onClose}>
            Close
          </button>
        </header>
        <div className={Styles.content}>
          <p className={Styles.helpText}>
            If you have any question regarding the sizing, a BLK DNM ambassador will be pleased to assist you.
          </p>
          <div className={Styles.unitSelector}>
            {units.map((unit, index) => (
              <button
                key={unit}
                onClick={() => {
                  handleSelectUnit(unit);
                }}
                className={cx(Styles.unitButton, {
                  [Styles.unitButtonActive]: index === selectedUnit,
                })}
              >
                {unit}
              </button>
            ))}
          </div>
          <div className={Styles.tableWrapper}>
            <table className={Styles.table}>
              <thead>
                <tr>
                  <th />
                  {measurementChart.x.map(x => (
                    <th key={x}>{x}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {measurementChart.y.map((y, indexY) => (
                  <tr key={y}>
                    <th>{y}</th>
                    {measurementChart.x.map((x, indexX) => {
                      const content = measurementChart.contents
                        .find(content => content.x === indexX && content.y === indexY)
                        ?.content?.split('/');

                      return <td key={`${indexY}-${indexX}`}>{content[selectedUnit]?.trim()}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
